import React, { useState } from 'react';
import { make_prop_change } from './util';

const PROCS = [
    {name: '20proc', display_name: '', ppm: 2.0, damage: 0},
    {name: '35proc', display_name: 'Regular proc', ppm: 3.5, damage: 71.75},
    {name: '45proc', display_name: 'Purple proc', ppm: 4.5, damage: 107.1},
    {name: '50proc', display_name: 'Superior ATO proc', ppm: 5.0, damage: 107.1}
];
const GROUP_CLASS = 'form-group col-md-2';
const CONTROL_CLASS = 'form-control form-control-sm';

export const ProcEntry = ({onAdd, onCancel}) => {
    const [data, setData] = useState({});

    const proc_change = (e) => {
        let proc_name = e.target.value;
        let proc = PROCS.find(val => val.name == proc_name);
        setData({proc: proc_name, name: proc.display_name, ppm: proc.ppm, damage: proc.damage});
    }

    const add_click = (e) => {
        onAdd(data);
    }

    return (
        <div>
            <div className="card">
            <div className="card-body pt-0">
                <div className="card-header">Proc</div>
                <h5 className="card-title">Presets</h5>
                <div className="form-row">
                <div className={GROUP_CLASS}>
                <label htmlFor="proc">Proc:</label>
                <select name="proc" id="proc" className={CONTROL_CLASS} onChange={proc_change}>
                    {PROCS.map(proc => (
                        <option key={proc.ppm} value={proc.name} selected={proc == data ? true : undefined}>{proc.display_name}</option>
                    ))}
                </select>
                </div>
                </div>
            <h5 className="card-title">Values</h5>
            <div className="form-row">
            <div className={GROUP_CLASS}>
                <label htmlFor="name">Name:</label>
                <input type="text" id="name" name="name" className={CONTROL_CLASS} value={data.name || ''} onChange={make_prop_change('name', data, setData)} />
            </div>
            <div className={GROUP_CLASS}>
                <label htmlFor="ppm">PPM:</label>
                <input type="text" id="ppm" name="ppm" className={CONTROL_CLASS} value={data.ppm || ''} onChange={make_prop_change('ppm', data, setData)} />
            </div>
            <div className={GROUP_CLASS}>
                <label htmlFor="damage">Damage:</label>
                <input type="text" id="damage" name="damage" className={CONTROL_CLASS} value={data.damage || ''} onChange={make_prop_change('damage', data, setData)} />
            </div>
            </div>
            <div>
                <button type="button" className="btn btn-primary" onClick={add_click}>Add</button>
                <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
            </div>
            </div>
            </div>
        </div>
    );
}